import map from 'lodash/map';
import { request } from 'lib';

import { store } from './store';

const init = async () => {
  const res = await request.api.get('public/gift_marquee/3');

  const { data = [] } = res;

  if (!data) {
    return;
  }
  const items = map(data, (item) => item.data_d);
  items.forEach((item) => {
    store.pushMarqueeItem(item.gift ? 'Gift' : 'Common', item);
  });

  // setInterval(() => {
  //   store.pushMarqueeItem(items[0].gift ? 'Gift' : 'Common', items[0]);
  // }, 1000);

  // store.updateRecentMarquees(items)
};

export default {
  init,
};
